"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const categories_1 = require("companion-app-components/flux/categories");
const transactions_1 = require("companion-app-components/flux/transactions");
const mui_1 = require("tss-react/mui");
const AlarmOn_1 = __importDefault(require("@mui/icons-material/AlarmOn"));
const AmountField_1 = require("components/QuickenControls/AmountField");
const utils_1 = require("data/transactions/utils");
const styles_1 = require("../../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.transactionLabelStyles);
function getTxnTypeClasses(type, classes) {
    // @ts-expect-error Property 'calTxnLabelTypes' does not exist on type 'typeof transactionsTypes'.
    const { income, expense, overdue, normal, more } = transactions_1.transactionsTypes.calTxnLabelTypes;
    switch (type) {
        case more:
            return classes.moreType;
        case income:
        case expense:
            return classes.dueType;
        case overdue:
            return classes.overdueType;
        case normal:
        default:
            return null; // classes.normalType
    }
}
const TransactionLabel = (props) => {
    const { classes, cx } = useStyles();
    const { txn, showMoreLabel, extraTxns } = props;
    const incomeCOAIds = (0, react_redux_1.useSelector)((state) => !showMoreLabel && categories_1.categoriesSelectors.getIncomeCOAIds(state));
    // @ts-expect-error Property 'calTxnLabelTypes' does not exist on type 'typeof transactionsTypes'.
    const type = (0, react_1.useMemo)(() => !showMoreLabel ? (0, utils_1.getCalendarTxnType)(txn, incomeCOAIds) : transactions_1.transactionsTypes.calTxnLabelTypes.more, [showMoreLabel, txn, incomeCOAIds]);
    const typeClasses = (0, react_1.useMemo)(() => getTxnTypeClasses(type, classes), [type, classes]);
    const isIncome = (0, react_1.useMemo)(() => !showMoreLabel && txn && parseFloat(txn.amount) > 0.0, [txn, showMoreLabel]);
    const payeeLabel = (0, react_1.useMemo)(() => !showMoreLabel ? txn && txn.payee : `${extraTxns} more...`, [showMoreLabel, txn, extraTxns]);
    const amountLabel = (0, react_1.useMemo)(() => !showMoreLabel && txn && (0, AmountField_1.formatNumber)(txn.amount, 'USD', '0,00.00'), [showMoreLabel, txn]);
    return (<div className={cx(classes.txnLabel, { [typeClasses]: Boolean(typeClasses) }, isIncome ? classes.incomeType : classes.expenseType)}>
      <div className={classes.payeeLabel}>
        <AlarmOn_1.default className={classes.reminderIcon}/>
        <span>{payeeLabel}</span>
      </div>
      {amountLabel && <div className={classes.amountLabel}>{amountLabel}</div>}
    </div>);
};
exports.default = react_1.default.memo(TransactionLabel);
